// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.react-modal-overlay.habit-create-edit-modal .react-modal {
  width: 40rem;
  height: -moz-fit-content;
  height: fit-content;
  max-height: 90%;
  margin: auto;
  padding: 0;
}
@media (max-width: 768px) {
  .react-modal-overlay.habit-create-edit-modal .react-modal {
    width: 35rem;
  }
}
.react-modal-overlay.habit-create-edit-modal .react-modal-content {
  width: 100%;
  display: flex;
  padding: unset;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
}
.react-modal-overlay.habit-create-edit-modal .react-modal .btn-default {
  min-width: 12rem;
  border: 0;
  background: 0;
  border-radius: 0;
  color: #696969;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Pages/Habits/HabitModalCreateEdit.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AAEE;EACE,YAAA;EACA,wBAAA;EAAA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;AACJ;AAAI;EANF;IAOI,YAAA;EAGJ;AACF;AADI;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;AAGN;AADI;EACE,gBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;AAGN","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import 'Variables.scss';\n\n.react-modal-overlay.habit-create-edit-modal {\n  .react-modal {\n    width: 40rem;\n    height: fit-content;\n    max-height: 90%;\n    margin: auto;\n    padding: 0;\n    @media (max-width: $tablet) {\n      width: 35rem;\n    }\n\n    &-content {\n      width: 100%;\n      display: flex;\n      padding: unset;\n      flex-direction: column;\n      padding-left: 20px;\n      padding-right: 20px;\n    }\n    .btn-default {\n      min-width: 12rem;\n      border: 0;\n      background: 0;\n      border-radius: 0;\n      color: #696969;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
